'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));
var React = require('react');
var React__default = _interopDefault(React);
var __chunk_1 = require('../_virtual/_rollupPluginBabelHelpers.js');
var icons = require('../icons.js');
var __chunk_3 = require('./social-login-base-button.js');

/**
 * @name FacebookLoginButton
 * @extends SocialLoginButton
 *
 * @example
 * <FacebookLoginButton onClick={handleClick} title="Facebook Login" label="on" />
 *
 */

function FacebookLoginButton(props) {
  var style = {
    background: '#3d5a9a',
    backgroundHover: '#3d5a9a',
    color: 'white'
  };
  return React__default.createElement(__chunk_3.SocialLoginBaseButton, __chunk_1.extends({}, props, {
    icon: React__default.createElement(icons.FacebookIcon, null),
    style: style
  }));
}
FacebookLoginButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.oneOf(['on', 'off']),
  variant: PropTypes.oneOf(['primary', 'minimal-round', 'minimal']),
  disableIcon: PropTypes.bool,
  icon: PropTypes.element,
  disabled: PropTypes.bool
  /**
   * @name TelgramLoginButton
   * @extends SocialLoginButton
   *
   * @example
   * <TelegramLoginButton onClick={handleClick} title="Facebook Login" label="on" />
   *
   */

};
function TelegramLoginButton(props) {
  var style = {
    background: '#29B6F6',
    backgroundHover: '#29B6F6',
    color: 'white'
  };
  return React__default.createElement(__chunk_3.SocialLoginBaseButton, __chunk_1.extends({}, props, {
    icon: React__default.createElement(icons.TelegramIcon, null),
    style: style
  }));
}
TelegramLoginButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.oneOf(['on', 'off']),
  variant: PropTypes.oneOf(['primary', 'minimal-round', 'minimal']),
  disableIcon: PropTypes.bool,
  icon: PropTypes.element,
  disabled: PropTypes.bool
  /**
   * @name GoogleLoginButton
   * @extends SocialLoginButton
   *
   * @example
   * <GoogleLoginButton onClick={handleClick} title="Facebook Login" label="on" />
   *
   */

};
function GoogleLoginButton(props) {
  var style = {
    background: 'white',
    backgroundHover: '#e6e3e3',
    color: 'black'
  };
  return React__default.createElement(__chunk_3.SocialLoginBaseButton, __chunk_1.extends({}, props, {
    icon: React__default.createElement(icons.GoogleIcon, null),
    style: style
  }));
}
GoogleLoginButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.oneOf(['on', 'off']),
  variant: PropTypes.oneOf(['primary', 'minimal-round', 'minimal']),
  disableIcon: PropTypes.bool,
  icon: PropTypes.element,
  disabled: PropTypes.bool // expose base for building social login buttons

};

exports.SocialLoginBaseButton = __chunk_3.SocialLoginBaseButton;
exports.FacebookLoginButton = FacebookLoginButton;
exports.GoogleLoginButton = GoogleLoginButton;
exports.TelegramLoginButton = TelegramLoginButton;
//# sourceMappingURL=index.js.map
